// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"77d729da","221":"286705b0","735":"4be47f4c"}[chunkId] + ".chunk.css";
};